import { TSidebarLink } from '@widgets/sidebar-layout';
import { Box, Gallery } from 'iconsax-react';
import { language } from './language';

export const managementSidebarLinks: TSidebarLink[] = [
  {
    id: 'management-cache',
    icon: <Box size={20} />,
    route: '/management/cache',
    label: language.cache,
  },
  {
    id: 'management-banner',
    icon: <Gallery size={20} />,
    route: '/management/banner',
    label: language.banner,
  },
  {
    id: 'management-redirectRule',
    icon: <Gallery size={20} />,
    route: '/management/redirectRule',
    label: language.rule,
  },
];
